import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Admin from '../../../Api/Models/Admin';
import Card from '../../elements/common/Card';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import useNumberParams from '../../hooks/useNumberParams';
import AdminForm from './AdminForm';

import AdminsApi from 'Api/CRM/Modules/AdminsApi';
import Loader from '../../elements/Loader';
function AdminEdit({ id }: { id?: number }) {
    const adminId = id ?? useNumberParams().id;
    const [admin, setAdmin] = useState<Admin | null>(null);
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        setIsLoading(true);
        AdminsApi.getModelById(Admin, adminId)
            .then(setAdmin)
            .finally(() => setIsLoading(false));
    }, [adminId]);

    const handleEditAdmin = async (newAdmin: Admin) => {
        try {
            setIsLoading(true);
            const updatedAdmin = await AdminsApi.updateModel(newAdmin);
            setAdmin(updatedAdmin);
            history.push('/admins');
        } catch (error) {
            handleValidationErrors(error, setErrors);
        } finally {
            setIsLoading(false);
        }
    };

    const getContent = () => {
        return (
            <Card title="Update Admin">
                <AdminForm action={handleEditAdmin} errors={errors} adminData={admin} />
            </Card>
        )
    }

    return <Loader loading={isLoading} content={getContent} />
}

export default AdminEdit;
